import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";

import { getBeneficiary, getToken, getUser } from "../services/user-service";
import { Radio, RadioGroup } from "@mui/joy";
import { formatAmount } from "./Common";

function SharedBeneficiaryEdit({
  assetName,
  responseData,
  responseAssetData,
  handleTrustSave,
  assetData,
  trusts,
  handleChanges,
  sharedType,
  handleCloseBeneficiaryPopup,
  estimatedTotalAmount,
  typeBeneficiary,
  sharedDetails,
}) {
  const [data, setData] = useState({
    sharedDetails: sharedDetails || [
      {
        distributedType: "",
        distributedValue: "",
        distributedAmount: "",
        beneficiaryId: "",
      },
    ],
  });

  const [selectedBeneficiaries, setSelectedBeneficiaries] = useState([]);
  const [beneficiaryDetails, setBeneficiaryDetails] = useState({});
  const [beneficiary, setBenificiary] = useState([]);
  const [isDataLoaded, setIsDataLoaded] = useState(false);

  const [distributedType, setDistributedType] = useState(
    assetName === "jewelry" ||
      assetName === "otherAsset" ||
      assetName === "cryptoAssest"
      ? "percentage"
      : ""
  );

  const handleReset = () => {
    if (isDataLoaded && selectedBeneficiaries.length > 0) {
      return;
    }

    setDistributedType("");
    setSelectedBeneficiaries([]);
    setBeneficiaryDetails({});
  };

  const getBenificiarydata = () => {
    let userId = getUser().commonId;
    let token = "Bearer " + getToken();
    getBeneficiary(token, userId)
      .then((res) => {
        setBenificiary(res);
      })
      .catch((err) => {});
  };

  useEffect(() => {
    getBenificiarydata();
  }, []);

  const handleDistributionTypeChange = (event) => {
    const newType = event.target.value;
    const resetDetails = {};
    Object.keys(beneficiaryDetails).forEach((beneficiaryKey) => {
      const currentDetail = beneficiaryDetails[beneficiaryKey];
      const estimatedTotal = parseFloat(estimatedTotalAmount) || 0;

      if (newType === "percentage") {
        const dollarValue = parseFloat(currentDetail.dollar) || 0;
        const percentage =
          estimatedTotal > 0 ? (dollarValue / estimatedTotal) * 100 : 0;
        resetDetails[beneficiaryKey] = {
          percentage: percentage > 0 ? percentage.toFixed(2) : "",
          dollar: dollarValue > 0 ? dollarValue.toFixed(2) : "",
        };
      } else if (newType === "dollar") {
        const percentage = parseFloat(currentDetail.percentage) || 0;
        const dollarValue = (percentage / 100) * estimatedTotal;
        resetDetails[beneficiaryKey] = {
          percentage: percentage > 0 ? percentage.toFixed(2) : "",
          dollar: dollarValue > 0 ? dollarValue.toFixed(2) : "",
        };
      }
    });

    setDistributedType(newType);
    setBeneficiaryDetails(resetDetails);
  };

  const handleBeneficiarySelection = (event) => {
    const selectedBeneficiary = event.target.value;
    if (assetName === "jewelry" || assetName === "otherAsset") {
      if (selectedBeneficiaries.length > 0) {
        toast.error(
          "Only one beneficiary can be assigned to this asset at 100%"
        );
        return;
      }

      const estimatedTotal = parseFloat(estimatedTotalAmount) || 0;
      const newBeneficiaryDetails = {
        [selectedBeneficiary]: {
          percentage: "100",
          dollar: estimatedTotal.toFixed(2),
        },
      };

      setSelectedBeneficiaries([selectedBeneficiary]);
      setBeneficiaryDetails(newBeneficiaryDetails);
      setDistributedType("percentage");
      setUtilisedValue(estimatedTotal);
      return;
    }

    if (!selectedBeneficiaries.includes(selectedBeneficiary)) {
      setSelectedBeneficiaries([...selectedBeneficiaries, selectedBeneficiary]);
      setBeneficiaryDetails({
        ...beneficiaryDetails,
        [selectedBeneficiary]: { percentage: "", dollar: "" },
      });
    }
  };

  const getBenificiaryName = (id) => {
    var foundBenificiary = null;
    if (id.beneficiary === undefined) {
      foundBenificiary = beneficiary.find((b) => b.id === parseInt(id));
    } else {
      foundBenificiary = beneficiary.find(
        (b) => b.id === parseInt(id.beneficiary)
      );
    }

    if (foundBenificiary) {
      return `${foundBenificiary.firstName} ${foundBenificiary.lastName}`;
    } else {
      return "Beneficiary not found";
    }
  };

  const calculateTotalUtilizedValue = (details) => {
    let total = 0;

    if (details && typeof details === "object") {
      Object.keys(details).forEach((key) => {
        const dollarValue = parseFloat(details[key]?.dollar) || 0;
        if (!isNaN(dollarValue) && dollarValue > 0) {
          total += dollarValue;
        }
      });
    }

    return Math.round(total * 100) / 100;
  };

  const [utilisedValue, setUtilisedValue] = useState(0);
  useEffect(() => {
    const newTotal = calculateTotalUtilizedValue(beneficiaryDetails);
    setUtilisedValue(newTotal);
  }, [beneficiaryDetails]);

  const handleFieldChange = (beneficiary, field, value) => {
    const estimatedTotal = parseFloat(estimatedTotalAmount);
    const tolerance = 0.1;

    if (!estimatedTotal || estimatedTotal === 0) {
      toast.error(
        "Please provide a valid estimated value before adding allocations!"
      );
      return;
    }

    let updatedDetails = { ...beneficiaryDetails };

    if (!updatedDetails[beneficiary]) {
      updatedDetails[beneficiary] = { percentage: "", dollar: "" };
    }

    if (value !== "" && !/^\d*\.?\d*$/.test(value)) {
      return;
    }

    let parsedValue = value === "" ? 0 : parseFloat(value);
    if (isNaN(parsedValue) || parsedValue < 0) {
      parsedValue = 0;
    }

    if (field === "percentage") {
      const newDollarValue = (parsedValue / 100) * estimatedTotal;
      updatedDetails[beneficiary] = {
        ...updatedDetails[beneficiary],
        percentage: value,
        dollar: newDollarValue.toFixed(2),
      };
    } else if (field === "dollar") {
      const newPercentageValue =
        estimatedTotal > 0 ? (parsedValue / estimatedTotal) * 100 : 0;
      updatedDetails[beneficiary] = {
        ...updatedDetails[beneficiary],
        percentage: newPercentageValue.toFixed(2),
        dollar: value,
      };
    }

    let totalPercentage = 0;
    let totalValue = 0;

    Object.keys(updatedDetails).forEach((key) => {
      const beneficiaryPercentage =
        parseFloat(updatedDetails[key]?.percentage) || 0;
      const beneficiaryValue = parseFloat(updatedDetails[key]?.dollar) || 0;

      if (!isNaN(beneficiaryPercentage) && beneficiaryPercentage >= 0) {
        totalPercentage += beneficiaryPercentage;
      }
      if (!isNaN(beneficiaryValue) && beneficiaryValue >= 0) {
        totalValue += beneficiaryValue;
      }
    });
    if (
      totalPercentage > 100 + tolerance ||
      totalValue > estimatedTotal + tolerance
    ) {
      toast.error("Total allocation limit exceeded! Changes reverted.");
      return;
    }
    setBeneficiaryDetails(updatedDetails);
  };

  const calculateDistributedAmount = (
    distributedType,
    balance,
    beneficiaryDetail
  ) => {
    const balanceValue = parseFloat(balance) || 0;

    if (distributedType === "percentage") {
      const percentage = parseFloat(beneficiaryDetail?.percentage) || 0;
      const calculatedAmount = (balanceValue * percentage) / 100;
      return calculatedAmount.toFixed(2);
    } else if (distributedType === "dollar") {
      const detailValue = parseFloat(beneficiaryDetail?.dollar) || 0;
      return detailValue.toFixed(2);
    }
    return "0.00";
  };

  const handleSave = () => {
    const newSharedDetails = [];

    const isJewelry = assetName === "jewelry" || assetName === "otherAsset";

    if (isJewelry) {
      const activeBeneficiaryKey = Object.keys(beneficiaryDetails).find(
        (key) => {
          const detail = beneficiaryDetails[key];
          const beneficiaryPercentage = parseFloat(detail?.percentage) || 0;
          const beneficiaryValue = parseFloat(detail?.dollar) || 0;
          return beneficiaryPercentage > 0 || beneficiaryValue > 0;
        }
      );

      if (activeBeneficiaryKey) {
        const detail = beneficiaryDetails[activeBeneficiaryKey];
        const beneficiaryPercentage = parseFloat(detail.percentage) || 0;
        const beneficiaryValue = parseFloat(detail.dollar) || 0;

        const distributedAmount = calculateDistributedAmount(
          distributedType,
          estimatedTotalAmount,
          detail
        );

        const valueToSave =
          distributedType === "percentage"
            ? beneficiaryPercentage
            : beneficiaryValue;

        newSharedDetails.push({
          distributedType: distributedType,
          distributedValue: valueToSave,
          distributedAmount: parseFloat(distributedAmount),
          beneficiaryId: parseInt(activeBeneficiaryKey),
        });
      }
    } else {
      Object.keys(beneficiaryDetails).forEach((key) => {
        const detail = beneficiaryDetails[key];
        const beneficiaryPercentage = parseFloat(detail?.percentage) || 0;
        const beneficiaryValue = parseFloat(detail?.dollar) || 0;
        if (beneficiaryPercentage > 0 || beneficiaryValue > 0) {
          const distributedAmount = calculateDistributedAmount(
            distributedType,
            estimatedTotalAmount,
            detail
          );

          const valueToSave =
            distributedType === "percentage"
              ? beneficiaryPercentage
              : beneficiaryValue;

          newSharedDetails.push({
            distributedType: distributedType,
            distributedValue: valueToSave,
            distributedAmount: parseFloat(distributedAmount),
            beneficiaryId: parseInt(key),
          });
        }
      });
    }

    setData({ sharedDetails: newSharedDetails });
    handleCloseBeneficiaryPopup({ name: newSharedDetails });
  };

  useEffect(() => {
    if (beneficiary.length > 0 && !isDataLoaded) {
      const copiedSharedDetails =
        sharedDetails !== undefined &&
        Array.isArray(sharedDetails) &&
        sharedDetails.length > 0 &&
        sharedDetails[0]?.distributedType !== undefined &&
        sharedDetails[0]?.distributedType !== ""
          ? [...sharedDetails]
          : [];

      if (copiedSharedDetails.length > 0) {
        const loadedType = copiedSharedDetails[0]?.distributedType;
        setDistributedType(loadedType);
        const loadedBeneficiaries = [];
        const loadedDetails = {};
        const estimatedTotal = parseFloat(estimatedTotalAmount) || 0;

        copiedSharedDetails.forEach((detail) => {
          if (detail.beneficiaryId) {
            loadedBeneficiaries.push(detail.beneficiaryId);

            const distributedValue = parseFloat(detail.distributedValue) || 0;
            const distributedAmount = parseFloat(detail.distributedAmount) || 0;
            if (detail.distributedType === "percentage") {
              loadedDetails[detail.beneficiaryId] = {
                percentage: distributedValue.toString(),
                dollar: distributedAmount.toFixed(2),
              };
            } else if (detail.distributedType === "dollar") {
              const calculatedPercentage =
                estimatedTotal > 0
                  ? (distributedValue / estimatedTotal) * 100
                  : 0;
              loadedDetails[detail.beneficiaryId] = {
                percentage: calculatedPercentage.toFixed(2),
                dollar: distributedValue.toString(),
              };
            }
          }
        });

        setSelectedBeneficiaries(loadedBeneficiaries);
        setBeneficiaryDetails(loadedDetails);
        const calculatedUtilized = calculateTotalUtilizedValue(loadedDetails);
        setUtilisedValue(calculatedUtilized);

        setIsDataLoaded(true);
      }
    }
  }, [beneficiary, isDataLoaded, estimatedTotalAmount]);

  const percentageUtilized = (utilised, total) => {
    const totalVal = parseFloat(total) || 0;
    const utilizedVal = parseFloat(utilised) || 0;

    if (totalVal === 0) {
      return "0.0";
    }

    const percentage = (utilizedVal / totalVal) * 100;
    return percentage.toFixed(1);
  };

  return (
    <>
      <div className="popup">
        <div
          className="popup-content"
          style={{
            minWidth: "350px",
            width: "100%",
            maxWidth: "700px",
          }}
        >
          <div className="note_popup">
            <div className="note_popup_heading">
              <div className="share_property_heading">
                <h2>Share Property </h2>
              </div>
              <div>
                <button
                  className="note_popup_heading_close_btn"
                  onClick={handleCloseBeneficiaryPopup}
                >
                  <FontAwesomeIcon icon={faXmark} />
                </button>
              </div>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                gap: "20px",
              }}
            >
              <p>Do you want to share your asset to beneficiary or trust?</p>
              <RadioGroup
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  gap: "20px",
                  margin: "8px 0",
                }}
                defaultValue="medium"
                name="radio-buttons-group"
                value={sharedType}
                onChange={(e) => {
                  typeBeneficiary === "normal"
                    ? handleChanges(e, "sharedType")
                    : handleChanges(e, "deathBenefitsSharedType");
                  handleReset(e);
                }}
              >
                <Radio
                  disabled={
                    (sharedType === "Beneficiary" || sharedType === "Trust") &&
                    ((responseAssetData?.trust &&
                      responseAssetData?.trust !== "") ||
                      (responseAssetData?.beneficiaryName &&
                        responseAssetData?.beneficiaryName !== "") ||
                      (responseData?.sharedDetails[0]?.id !== "" &&
                        responseData?.sharedDetails[0]?.id !== undefined))
                  }
                  value="Beneficiary"
                  label="Beneficiary"
                />
                <Radio
                  disabled={
                    (sharedType === "Beneficiary" || sharedType === "Trust") &&
                    ((responseAssetData?.trust &&
                      responseAssetData?.trust !== "") ||
                      (responseAssetData?.beneficiaryName &&
                        responseAssetData?.beneficiaryName !== "") ||
                      (responseData?.sharedDetails[0]?.id !== "" &&
                        responseData?.sharedDetails[0]?.id !== undefined))
                  }
                  sx={{ margin: 0 }}
                  value="Trust"
                  label="Trust"
                />
              </RadioGroup>
            </div>

            {sharedType ? (
              <div style={{ marginTop: "8px" }}>
                <div className="share_property_est_value">
                  <p>
                    Total Estimated Value:{" "}
                    <code style={{ color: "green", fontWeight: "bold" }}>
                      ${estimatedTotalAmount}
                    </code>
                  </p>
                  <p>
                    Unutilised Value:{" "}
                    <code style={{ color: "green", fontWeight: "bold" }}>
                      {formatAmount(
                        Math.max(
                          0,
                          (parseFloat(estimatedTotalAmount) || 0) -
                            (parseFloat(utilisedValue) || 0)
                        )
                      )}
                    </code>
                  </p>
                </div>
                {sharedType === "Beneficiary" ? (
                  <>
                    <div className="BeneficiarySelect">
                      <div className="BeneficiarySelectContainer">
                        <div className="BeneficiarySelectRow">
                          <div className="share_property_Type">
                            <p className="share_property_Type_paragraph">
                              Choose Distribution Type:{" "}
                            </p>
                            <select
                              value={
                                assetName === "jewelry" ||
                                assetName === "otherAsset" ||
                                assetName === "cryptoAssest"
                                  ? "percentage"
                                  : distributedType
                              }
                              onChange={handleDistributionTypeChange}
                              className="share_property_Type_select"
                              disabled={
                                assetName === "jewelry" ||
                                assetName === "otherAsset" ||
                                assetName === "cryptoAssest"
                              }
                            >
                              <option value="" disabled>
                                Select Type
                              </option>
                              <option value="percentage">Percentage</option>
                              <option value="dollar">Dollar</option>
                            </select>
                          </div>
                          <div className="SelectContainer">
                            <select
                              className="Property-inputfiled"
                              onChange={handleBeneficiarySelection}
                              value={
                                (assetName === "jewelry" ||
                                  assetName === "otherAsset") &&
                                selectedBeneficiaries.length > 0
                                  ? selectedBeneficiaries[0]
                                  : ""
                              }
                              disabled={
                                assetName === "jewelry" ||
                                assetName === "otherAsset"
                                  ? selectedBeneficiaries.length > 0
                                  : !distributedType &&
                                    assetName !== "cryptoAssest"
                              }
                            >
                              <option value="" disabled hidden>
                                {(assetName === "jewelry" ||
                                  assetName === "otherAsset") &&
                                selectedBeneficiaries.length > 0
                                  ? "Beneficiary Already Assigned (100%)"
                                  : distributedType ||
                                    assetName === "jewelry" ||
                                    assetName === "otherAsset" ||
                                    assetName === "cryptoAssest"
                                  ? "Select Your Beneficiary Username"
                                  : "Select Type First"}
                              </option>
                              {beneficiary.map((benif) => (
                                <option
                                  key={benif.id}
                                  value={benif.id}
                                  disabled={selectedBeneficiaries.includes(
                                    benif.id
                                  )}
                                >
                                  {`${benif.firstName} ${benif.lastName}`}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>

                        <div className="share_beneficiary_main_card">
                          {selectedBeneficiaries.map((beneficiaryId) => (
                            <div
                              key={beneficiaryId}
                              className="share_beneficiary_card"
                            >
                              <div>
                                <p className="share_beneficiary_card_para">
                                  Beneficiary:{" "}
                                  {getBenificiaryName({
                                    beneficiary: beneficiaryId,
                                  })}
                                </p>
                                {assetName === "jewelry" ||
                                assetName === "otherAsset" ? (
                                  <p className="share_beneficiary_card_para">
                                    Fixed 100% of asset is assigned.
                                  </p>
                                ) : (
                                  <>
                                    {distributedType === "percentage" && (
                                      <input
                                        type="text"
                                        className="share_ben_percentage"
                                        placeholder="Percentage"
                                        value={
                                          beneficiaryDetails[beneficiaryId]
                                            ?.percentage || ""
                                        }
                                        onChange={(e) =>
                                          handleFieldChange(
                                            beneficiaryId,
                                            "percentage",
                                            e.target.value
                                          )
                                        }
                                      />
                                    )}
                                    {distributedType === "dollar" && (
                                      <input
                                        type="text"
                                        className="share_ben_percentage"
                                        placeholder="Dollar Value"
                                        value={
                                          beneficiaryDetails[beneficiaryId]
                                            ?.dollar || ""
                                        }
                                        onChange={(e) =>
                                          handleFieldChange(
                                            beneficiaryId,
                                            "dollar",
                                            e.target.value
                                          )
                                        }
                                      />
                                    )}
                                  </>
                                )}
                                {distributedType &&
                                  beneficiaryDetails[beneficiaryId] && (
                                    <>
                                      <p className="share_beneficiary_card_para">
                                        Distributed Value: $
                                        {calculateDistributedAmount(
                                          distributedType,
                                          estimatedTotalAmount,
                                          beneficiaryDetails[beneficiaryId]
                                        )}
                                      </p>
                                      {distributedType === "dollar" && (
                                        <p
                                          className="share_beneficiary_card_para"
                                          style={{
                                            fontSize: "0.9em",
                                            color: "#666",
                                          }}
                                        >
                                          (
                                          {(
                                            parseFloat(
                                              beneficiaryDetails[beneficiaryId]
                                                ?.percentage
                                            ) || 0
                                          ).toFixed(2)}
                                          % of total)
                                        </p>
                                      )}
                                      {distributedType === "percentage" && (
                                        <p
                                          className="share_beneficiary_card_para"
                                          style={{
                                            fontSize: "0.9em",
                                            color: "#666",
                                          }}
                                        >
                                          (
                                          {(
                                            parseFloat(
                                              beneficiaryDetails[beneficiaryId]
                                                ?.percentage
                                            ) || 0
                                          ).toFixed(2)}
                                          % of total)
                                        </p>
                                      )}
                                    </>
                                  )}
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </>
                ) : (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      gap: "8px",
                      margin: "12px 0",
                    }}
                  >
                    <p>Select your trust where you want to share your asset:</p>
                    <select
                      value={assetData?.trust}
                      onChange={(e) => handleChanges(e, "trust")}
                      className="share_property_Type_select"
                    >
                      <option value={""}>{"Select your trust"}</option>
                      {trusts.map((trust) => (
                        <option key={trust.id} value={trust?.trustName}>
                          {trust?.trustName}
                        </option>
                      ))}
                    </select>
                  </div>
                )}
              </div>
            ) : (
              <></>
            )}
          </div>
          <span style={{ color: "red", fontWeight: "bold" }}>
            {percentageUtilized(utilisedValue, estimatedTotalAmount)}% of the
            Estimated Value is already being utilised
          </span>
          {(assetName === "jewelry" || assetName === "otherAsset"
            ? selectedBeneficiaries.length > 0
            : selectedBeneficiaries.length > 0 ||
              (sharedDetails.length > 0 &&
                sharedDetails[0].distributedType !== "")) && (
            <button
              onClick={() => {
                handleSave();
              }}
            >
              Save
            </button>
          )}
          {((assetData?.trust !== "" &&
            assetData?.trust !== null &&
            assetData?.trust !== undefined) ||
            (assetData?.beneficiaryName !== "" &&
              assetData?.beneficiaryName !== null &&
              assetData?.beneficiaryName !== undefined)) && (
            <button onClick={handleTrustSave}>Save</button>
          )}

          {typeBeneficiary === "death-benefits" &&
            assetData?.deathBenefits?.trust !== null &&
            assetData?.deathBenefits?.trust !== "" &&
            assetData?.deathBenefits?.trust !== undefined && (
              <button onClick={handleTrustSave}>Save</button>
            )}
        </div>
      </div>
    </>
  );
}

export default SharedBeneficiaryEdit;
